import { render, staticRenderFns } from "./RoleGuide.vue?vue&type=template&id=910a9904"
import script from "./RoleGuide.vue?vue&type=script&lang=js"
export * from "./RoleGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports